import { render } from "./InvoicesTable.vue?vue&type=template&id=3c74e5d4&scoped=true"
import script from "./InvoicesTable.vue?vue&type=script&lang=js"
export * from "./InvoicesTable.vue?vue&type=script&lang=js"

import "./InvoicesTable.vue?vue&type=style&index=0&id=3c74e5d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c74e5d4"]])

export default __exports__